import React from 'react';
import './About.scss';
import { images } from '../../constants';
import { motion } from 'framer-motion';
import { AppWrap, MotionWrap } from '../../wrapper';

const abouts = [
    { title: 'Web Development', imgUrl: images.about01},
    { title: 'Web Design', imgUrl: images.about02},
    { title: 'Responsive Design', imgUrl: images.about03},
    { title: 'Graphic Design', imgUrl: images.about04},
]

const About = () => {
    return (
        <>
            <h2 className='head-text'>I Know That <span>Good Development</span><br />means <span>Good Business</span>
            </h2>
            <div className='app__profiles'>
                {
                    abouts.map((about, index)=> (
                        <motion.div
                        whileInView={{opacity: 1}}
                        whileHover={{scale: 1.1}}
                        transition={{duration: 0.5, type: 'tween'}}
                        className='app__profile-item'
                        key={about.title + index}
                        >
                            <img src={about.imgUrl} alt={about.title} />
                            <h2 className='bold-text' style={{marginTop:20, margin: '0 auto'}}>{about.title}</h2>
                        </motion.div>
                    ))
                }
            </div>
        </>
    );
};

export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__whitebg',
);